



























import Vue from 'vue';
import Swiper from 'swiper';

import 'swiper/dist/css/swiper.min.css';

import PlanningPokerCard from '@/components/PlanningPokerCard.vue';

import cards, { Card } from '@/assets/cards.json';

interface ComponentData {
    cards: Card[],
    swiper: Swiper | null,
    keyboardListener: EventListener | null,
}

export default Vue.extend({
    components: {
        PlanningPokerCard,
    },
    data(): ComponentData {
        return {
            cards,
            swiper: null,
            keyboardListener: null,
        };
    },
    created() {
        const requireCardImage = require.context('@/assets/cards/', true);
        requireCardImage.keys().forEach((path: string) => {
            for (const card of this.cards) {
                if (path.indexOf(card.file) !== -1) {
                    card.url = requireCardImage(path);
                }
            }
        });

        window.addEventListener('keydown', this.keyboardListener = (e: Event) => {
            if (this.swiper) {
                switch((e as KeyboardEvent).keyCode) {
                    case 39: // arrow right
                        this.swiper.slideNext();
                        break;
                    case 37: // arrow left
                        this.swiper.slidePrev();
                        break;
                }
            }
        });
    },
    mounted() {
        this.swiper = new Swiper('#planning-poker-deck', {
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    },
    destroyed() {
        if (this.keyboardListener) {
            window.removeEventListener('keydown', this.keyboardListener);
            this.keyboardListener = null;
        }
        if (this.swiper) {
            this.swiper.destroy();
            this.swiper = null;
        }
    },
});
